import { render, staticRenderFns } from "./communications.vue?vue&type=template&id=0c0fee0b&scoped=true&"
import script from "./communications.vue?vue&type=script&lang=js&"
export * from "./communications.vue?vue&type=script&lang=js&"
import style0 from "./communications.vue?vue&type=style&index=0&id=0c0fee0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0fee0b",
  null
  
)

export default component.exports